export default {
  methods: {
    allowEnglishNumbersSymbols(value) {
      return value.replace(
        /[^A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g,
        ""
      );
    },
    allowArabicNumbersSymbols(value) {
      return value.replace(/[A-Za-z]/g, "");
    },
  },
};
